import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/service/rest.service';
import { SeoService } from 'src/app/service/seo.service';
import Swiper, { SwiperOptions } from 'swiper';
import { Router } from '@angular/router';
@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.css']
})
export class NewsListComponent implements OnInit {

  sliderNews;
  itemOne;
  itemtow;
  topNews;
  LatestNews: any;
  config: SwiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 15,
  };
  constructor(private rest: RestService, private seo: SeoService, private route: Router) { }

  count = 20
  pageindex = 1

  // Filter state.
  faculties: any[] = []        // institute options for the dropdown
  selectedFacultyId: any = ''  // '' = all institutes (server-side filter)
  keyword = ''                 // free-text search (client-side filter)
  allLatestNews: any[] = []    // unfiltered master list backing LatestNews

  ngOnInit(): void {
    window.scrollTo(0, 0)
    const name = this.rest.getFacultyIDAndName().FACULTY_NAME
    this.seo.update({
      title: `الأخبار - ${name}`,
      description: `آخر أخبار ${name} بأكاديمية الفنون.`,
      type: 'website'
    })
    this.getFaculties()
    this.getNews()
  }

  // Builds the institute dropdown, de-duplicated by id (a faculty can appear
  // under more than one branch).
  getFaculties() {
    this.rest.GetBranchesFaculties().subscribe((res: any) => {
      const seen = new Set()
      const list: any[] = []
      for (const branch of (res?.branches || [])) {
        for (const f of (branch?.faculty || [])) {
          if (!seen.has(f.ID)) {
            seen.add(f.ID)
            list.push({ ID: f.ID, FACULTY_NAME: f.FACULTY_NAME })
          }
        }
      }
      this.faculties = list
    })
  }

  getNews() {
    this.rest.getNews(this.count, this.pageindex, this.selectedFacultyId).subscribe((res: any) => {
      this.itemOne = [res.SliderNews[0]]
      this.itemtow = [res.SliderNews[1], res.SliderNews[2]]
      this.sliderNews = res.SliderNews
      this.topNews = res.TopNews
      this.allLatestNews = res.LatestNews || []
      this.applyKeyword()
    })
  }

  moreNews() {
    this.pageindex = this.pageindex + 1
    this.rest.getNews(this.count, this.pageindex, this.selectedFacultyId).subscribe((res: any) => {
      (res.LatestNews || []).forEach(element => {
        this.allLatestNews.push(element)
      });
      this.applyKeyword()
    })
  }

  // Institute changed: reset paging and reload from the server filtered by it.
  onFacultyChange() {
    this.pageindex = 1
    this.getNews()
  }

  // The news API ignores text search, so we match the keyword client-side
  // against the loaded items' title and brief.
  applyKeyword() {
    const q = this.normalize(this.keyword)
    if (!q) {
      this.LatestNews = this.allLatestNews
      return
    }
    this.LatestNews = this.allLatestNews.filter(item =>
      this.normalize(item?.TITLE).includes(q) ||
      this.normalize(item?.DETAILS).includes(q)
    )
  }

  // Clears both filters back to the default (all institutes, no keyword).
  clearFilters() {
    this.keyword = ''
    this.selectedFacultyId = ''
    this.pageindex = 1
    this.getNews()
  }

  // Lowercase + strip Arabic diacritics/spelling variants so the search is
  // forgiving of أ/إ/آ, ى, ة, tatweel and extra spaces.
  private normalize(text): string {
    return String(text || '')
      .toLowerCase()
      .replace(/[ً-ْـ]/g, '')
      .replace(/[أإآ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/\s+/g, ' ')
      .trim()
  }

  newsDetails(item) {
    this.route.navigate(['/news_details', item.ID])
  }

}
